"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EmitterBase_emitterAccessor;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reply = exports.EmitterBase = exports.Base = void 0;
const promises_1 = require("../util/promises");
class Base {
    constructor(wire) {
        this.isNodeEnvironment = () => {
            return this.wire.environment.constructor.name === 'NodeEnvironment';
        };
        this.isOpenFinEnvironment = () => {
            return this.wire.environment.constructor.name === 'OpenFinEnvironment';
        };
        this.isBrowserEnvironment = () => {
            return this.wire.environment.constructor.name === 'BrowserEnvironment';
        };
        this.wire = wire;
    }
    get fin() {
        return this.wire.getFin();
    }
    get me() {
        return this.wire.me;
    }
}
exports.Base = Base;
class EmitterBase extends Base {
    constructor(wire, topic, ...additionalAccessors) {
        super(wire);
        this.topic = topic;
        _EmitterBase_emitterAccessor.set(this, void 0);
        this.eventNames = () => (this.hasEmitter() ? this.getOrCreateEmitter().eventNames() : []);
        this.emit = (eventType, payload, ...args) => {
            return this.hasEmitter() ? this.getOrCreateEmitter().emit(eventType, payload, ...args) : false;
        };
        this.hasEmitter = () => this.wire.eventAggregator.has(__classPrivateFieldGet(this, _EmitterBase_emitterAccessor, "f"));
        this.getOrCreateEmitter = () => this.wire.eventAggregator.getOrCreate(__classPrivateFieldGet(this, _EmitterBase_emitterAccessor, "f"));
        this.listeners = (type) => this.hasEmitter() ? this.getOrCreateEmitter().listeners(type) : [];
        this.listenerCount = (type) => this.hasEmitter() ? this.getOrCreateEmitter().listenerCount(type) : 0;
        this.registerEventListener = async (eventType, options = {}, applySubscription, undoSubscription) => {
            const runtimeEvent = {
                ...this.identity,
                timestamp: options.timestamp || Date.now(),
                topic: this.topic,
                type: eventType
            };
            const emitter = this.getOrCreateEmitter();
            // We apply the subscription and then undo if the async call fails to avoid
            // indeterminacy in subscription application order, which can break things elsewhere
            applySubscription(emitter);
            try {
                await this.wire.sendAction('subscribe-to-desktop-event', runtimeEvent);
            }
            catch (e) {
                undoSubscription(emitter);
                this.deleteEmitterIfNothingRegistered(emitter);
                throw e;
            }
        };
        this.deregisterEventListener = async (eventType, options = {}) => {
            if (this.hasEmitter()) {
                const runtimeEvent = {
                    ...this.identity,
                    timestamp: options.timestamp || Date.now(),
                    topic: this.topic,
                    type: eventType
                };
                await this.wire.sendAction('unsubscribe-to-desktop-event', runtimeEvent).catch(() => null);
                const emitter = this.getOrCreateEmitter();
                return emitter;
            }
            // This will only be reached if unsubscribe from event that does not exist but do not want to error here
            return Promise.resolve();
        };
        this.addListener = this.on;
        __classPrivateFieldSet(this, _EmitterBase_emitterAccessor, [topic, ...additionalAccessors], "f");
        this.listeners = (event) => this.hasEmitter() ? this.getOrCreateEmitter().listeners(event) : [];
    }
    async on(eventType, listener, options) {
        await this.registerEventListener(eventType, options, (emitter) => {
            emitter.on(eventType, listener);
        }, (emitter) => {
            emitter.removeListener(eventType, listener);
        });
        return this;
    }
    async once(eventType, listener, options) {
        const deregister = () => this.deregisterEventListener(eventType);
        await this.registerEventListener(eventType, options, (emitter) => {
            emitter.once(eventType, deregister);
            emitter.once(eventType, listener);
        }, (emitter) => {
            emitter.removeListener(eventType, deregister);
            emitter.removeListener(eventType, listener);
        });
        return this;
    }
    async prependListener(eventType, listener, options) {
        await this.registerEventListener(eventType, options, (emitter) => {
            emitter.prependListener(eventType, listener);
        }, (emitter) => {
            emitter.removeListener(eventType, listener);
        });
        return this;
    }
    async prependOnceListener(eventType, listener, options) {
        const deregister = () => this.deregisterEventListener(eventType);
        await this.registerEventListener(eventType, options, (emitter) => {
            emitter.prependOnceListener(eventType, listener);
            emitter.once(eventType, deregister);
        }, (emitter) => {
            emitter.removeListener(eventType, listener);
            emitter.removeListener(eventType, deregister);
        });
        return this;
    }
    async removeListener(eventType, listener, options) {
        const emitter = await this.deregisterEventListener(eventType, options);
        if (emitter) {
            emitter.removeListener(eventType, listener);
            this.deleteEmitterIfNothingRegistered(emitter);
        }
        return this;
    }
    async deregisterAllListeners(eventType) {
        const runtimeEvent = { ...this.identity, type: eventType, topic: this.topic };
        if (this.hasEmitter()) {
            const emitter = this.getOrCreateEmitter();
            const refCount = emitter.listenerCount(runtimeEvent.type);
            const unsubscribePromises = [];
            for (let i = 0; i < refCount; i++) {
                unsubscribePromises.push(this.wire.sendAction('unsubscribe-to-desktop-event', runtimeEvent).catch(() => null));
            }
            await Promise.all(unsubscribePromises);
            return emitter;
        }
        return undefined;
    }
    async removeAllListeners(eventType) {
        const removeByEvent = async (event) => {
            const emitter = await this.deregisterAllListeners(event);
            if (emitter) {
                emitter.removeAllListeners(event);
                this.deleteEmitterIfNothingRegistered(emitter);
            }
        };
        if (eventType) {
            await removeByEvent(eventType);
        }
        else if (this.hasEmitter()) {
            const events = this.getOrCreateEmitter().eventNames();
            await (0, promises_1.promiseMap)(events, removeByEvent);
        }
        return this;
    }
    deleteEmitterIfNothingRegistered(emitter) {
        if (emitter.eventNames().length === 0) {
            this.wire.eventAggregator.delete(__classPrivateFieldGet(this, _EmitterBase_emitterAccessor, "f"));
        }
    }
}
exports.EmitterBase = EmitterBase;
_EmitterBase_emitterAccessor = new WeakMap();
class Reply {
}
exports.Reply = Reply;
